"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitSurvey = exports.setSurvey = exports.setAssessmentSectionsComplete = exports.saveSurveyChanges = exports.saveSurvey = exports.saveAssessmentAgreement = exports.getUserSurveys = exports.getSurveys = exports.getSurveyTypes = exports.getSurveyType = exports.getSurveyScore = exports.getSurveyAMAMScore = exports.getSurvey = exports.downLoadSurveyType = exports.downLoadSurveyPDF = exports.deleteSurvey = exports.createWizardSurvey = exports.createSurvey = exports.SUBMIT_SURVEY_SUCCESS = exports.SUBMIT_SURVEY_REQUEST = exports.SUBMIT_SURVEY_FAILURE = exports.SET_SURVEY = exports.SET_ASSESSMENT_SECTIONS_COMPLETE_SUCCESS = exports.SET_ASSESSMENT_SECTIONS_COMPLETE_REQUEST = exports.SET_ASSESSMENT_SECTIONS_COMPLETE_FAILURE = exports.SAVE_SURVEY_SUCCESS = exports.SAVE_SURVEY_REQUEST = exports.SAVE_SURVEY_FAILURE = exports.SAVE_SURVEY_CHANGES_SUCCESS = exports.SAVE_SURVEY_CHANGES_REQUEST = exports.SAVE_SURVEY_CHANGES_FAILURE = exports.SAVE_ASSESSMENT_AGREEMENT_SUCCESS = exports.SAVE_ASSESSMENT_AGREEMENT_REQUEST = exports.SAVE_ASSESSMENT_AGREEMENT_FAILURE = exports.GET_USER_SURVEYS_SUCCESS = exports.GET_USER_SURVEYS_REQUEST = exports.GET_USER_SURVEYS_FAILURE = exports.GET_SURVEY_TYPE_SUCCESS = exports.GET_SURVEY_TYPE_REQUEST = exports.GET_SURVEY_TYPE_FAILURE = exports.GET_SURVEY_TYPES_SUCCESS = exports.GET_SURVEY_TYPES_REQUEST = exports.GET_SURVEY_TYPES_FAILURE = exports.GET_SURVEY_SUCCESS = exports.GET_SURVEY_SCORE_SUCCESS = exports.GET_SURVEY_SCORE_REQUEST = exports.GET_SURVEY_SCORE_FAILURE = exports.GET_SURVEY_REQUEST = exports.GET_SURVEY_FAILURE = exports.GET_SURVEY_AMAM_SCORE_SUCCESS = exports.GET_SURVEY_AMAM_SCORE_REQUEST = exports.GET_SURVEY_AMAM_SCORE_FAILURE = exports.GET_SURVEYS_SUCCESS = exports.GET_SURVEYS_REQUEST = exports.GET_SURVEYS_FAILURE = exports.DOWNLOAD_SURVEY_TYPE_SUCCESS = exports.DOWNLOAD_SURVEY_TYPE_REQUEST = exports.DOWNLOAD_SURVEY_TYPE_FAILURE = exports.DOWNLOAD_SURVEY_PDF_SUCCESS = exports.DOWNLOAD_SURVEY_PDF_REQUEST = exports.DOWNLOAD_SURVEY_PDF_FAILURE = exports.DELETE_SURVEY_SUCCESS = exports.DELETE_SURVEY_REQUEST = exports.DELETE_SURVEY_FAILURE = exports.CREATE_WIZARD_SURVEY_SUCCESS = exports.CREATE_WIZARD_SURVEY_REQUEST = exports.CREATE_WIZARD_SURVEY_FAILURE = exports.CREATE_SURVEY_SUCCESS = exports.CREATE_SURVEY_REQUEST = exports.CREATE_SURVEY_FAILURE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("../middleware/api");
var DELETE_SURVEY_FAILURE = exports.DELETE_SURVEY_FAILURE = 'DELETE_SURVEY_FAILURE';
var DELETE_SURVEY_REQUEST = exports.DELETE_SURVEY_REQUEST = 'DELETE_SURVEY_REQUEST';
var DELETE_SURVEY_SUCCESS = exports.DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS';
var GET_SURVEYS_FAILURE = exports.GET_SURVEYS_FAILURE = 'GET_SURVEYS_FAILURE';
var GET_SURVEYS_REQUEST = exports.GET_SURVEYS_REQUEST = 'GET_SURVEYS_REQUEST';
var GET_SURVEYS_SUCCESS = exports.GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS';
var GET_SURVEY_FAILURE = exports.GET_SURVEY_FAILURE = 'GET_SURVEY_FAILURE';
var GET_SURVEY_REQUEST = exports.GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST';
var GET_SURVEY_SUCCESS = exports.GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
var GET_SURVEY_SCORE_FAILURE = exports.GET_SURVEY_SCORE_FAILURE = 'GET_SURVEY_SCORE_FAILURE';
var GET_SURVEY_SCORE_REQUEST = exports.GET_SURVEY_SCORE_REQUEST = 'GET_SURVEY_SCORE_REQUEST';
var GET_SURVEY_SCORE_SUCCESS = exports.GET_SURVEY_SCORE_SUCCESS = 'GET_SURVEY_SCORE_SUCCESS';
var GET_SURVEY_AMAM_SCORE_FAILURE = exports.GET_SURVEY_AMAM_SCORE_FAILURE = 'GET_SURVEY_AMAM_SCORE_FAILURE';
var GET_SURVEY_AMAM_SCORE_REQUEST = exports.GET_SURVEY_AMAM_SCORE_REQUEST = 'GET_SURVEY_AMAM_SCORE_REQUEST';
var GET_SURVEY_AMAM_SCORE_SUCCESS = exports.GET_SURVEY_AMAM_SCORE_SUCCESS = 'GET_SURVEY_AMAM_SCORE_SUCCESS';
var GET_SURVEY_TYPE_FAILURE = exports.GET_SURVEY_TYPE_FAILURE = 'GET_SURVEY_TYPE_FAILURE';
var GET_SURVEY_TYPE_REQUEST = exports.GET_SURVEY_TYPE_REQUEST = 'GET_SURVEY_TYPE_REQUEST';
var GET_SURVEY_TYPE_SUCCESS = exports.GET_SURVEY_TYPE_SUCCESS = 'GET_SURVEY_TYPE_SUCCESS';
var GET_SURVEY_TYPES_FAILURE = exports.GET_SURVEY_TYPES_FAILURE = 'GET_SURVEY_TYPES_FAILURE';
var GET_SURVEY_TYPES_REQUEST = exports.GET_SURVEY_TYPES_REQUEST = 'GET_SURVEY_TYPES_REQUEST';
var GET_SURVEY_TYPES_SUCCESS = exports.GET_SURVEY_TYPES_SUCCESS = 'GET_SURVEY_TYPES_SUCCESS';
var GET_USER_SURVEYS_FAILURE = exports.GET_USER_SURVEYS_FAILURE = 'GET_USER_SURVEYS_FAILURE';
var GET_USER_SURVEYS_REQUEST = exports.GET_USER_SURVEYS_REQUEST = 'GET_USER_SURVEYS_REQUEST';
var GET_USER_SURVEYS_SUCCESS = exports.GET_USER_SURVEYS_SUCCESS = 'GET_USER_SURVEYS_SUCCESS';
var SAVE_SURVEY_FAILURE = exports.SAVE_SURVEY_FAILURE = 'SAVE_SURVEY_FAILURE';
var SAVE_SURVEY_REQUEST = exports.SAVE_SURVEY_REQUEST = 'SAVE_SURVEY_REQUEST';
var SAVE_SURVEY_SUCCESS = exports.SAVE_SURVEY_SUCCESS = 'SAVE_SURVEY_SUCCESS';
var SUBMIT_SURVEY_FAILURE = exports.SUBMIT_SURVEY_FAILURE = 'SUBMIT_SURVEY_FAILURE';
var SUBMIT_SURVEY_REQUEST = exports.SUBMIT_SURVEY_REQUEST = 'SUBMIT_SURVEY_REQUEST';
var SUBMIT_SURVEY_SUCCESS = exports.SUBMIT_SURVEY_SUCCESS = 'SUBMIT_SURVEY_SUCCESS';
var SET_ASSESSMENT_SECTIONS_COMPLETE_FAILURE = exports.SET_ASSESSMENT_SECTIONS_COMPLETE_FAILURE = 'SET_ASSESSMENT_SECTIONS_COMPLETE_FAILURE';
var SET_ASSESSMENT_SECTIONS_COMPLETE_REQUEST = exports.SET_ASSESSMENT_SECTIONS_COMPLETE_REQUEST = 'SET_ASSESSMENT_SECTIONS_COMPLETE_REQUEST';
var SET_ASSESSMENT_SECTIONS_COMPLETE_SUCCESS = exports.SET_ASSESSMENT_SECTIONS_COMPLETE_SUCCESS = 'SET_ASSESSMENT_SECTIONS_COMPLETE_SUCCESS';
var CREATE_SURVEY_FAILURE = exports.CREATE_SURVEY_FAILURE = 'CREATE_SURVEY_FAILURE';
var CREATE_SURVEY_REQUEST = exports.CREATE_SURVEY_REQUEST = 'CREATE_SURVEY_REQUEST';
var CREATE_SURVEY_SUCCESS = exports.CREATE_SURVEY_SUCCESS = 'CREATE_SURVEY_SUCCESS';
var DOWNLOAD_SURVEY_TYPE_FAILURE = exports.DOWNLOAD_SURVEY_TYPE_FAILURE = 'DOWNLOAD_SURVEY_TYPE_FAILURE';
var DOWNLOAD_SURVEY_TYPE_REQUEST = exports.DOWNLOAD_SURVEY_TYPE_REQUEST = 'DOWNLOAD_SURVEY_TYPE_REQUEST';
var DOWNLOAD_SURVEY_TYPE_SUCCESS = exports.DOWNLOAD_SURVEY_TYPE_SUCCESS = 'DOWNLOAD_SURVEY_TYPE_SUCCESS';
var DOWNLOAD_SURVEY_PDF_FAILURE = exports.DOWNLOAD_SURVEY_PDF_FAILURE = 'DOWNLOAD_SURVEY_PDF_FAILURE';
var DOWNLOAD_SURVEY_PDF_REQUEST = exports.DOWNLOAD_SURVEY_PDF_REQUEST = 'DOWNLOAD_SURVEY_PDF_REQUEST';
var DOWNLOAD_SURVEY_PDF_SUCCESS = exports.DOWNLOAD_SURVEY_PDF_SUCCESS = 'DOWNLOAD_SURVEY_PDF_SUCCESS';
var SAVE_SURVEY_CHANGES_FAILURE = exports.SAVE_SURVEY_CHANGES_FAILURE = 'SAVE_SURVEY_CHANGES_FAILURE';
var SAVE_SURVEY_CHANGES_REQUEST = exports.SAVE_SURVEY_CHANGES_REQUEST = 'SAVE_SURVEY_CHANGES_REQUEST';
var SAVE_SURVEY_CHANGES_SUCCESS = exports.SAVE_SURVEY_CHANGES_SUCCESS = 'SAVE_SURVEY_CHANGES_SUCCESS';
var CREATE_WIZARD_SURVEY_REQUEST = exports.CREATE_WIZARD_SURVEY_REQUEST = 'CREATE_WIZARD_SURVEY_REQUEST';
var CREATE_WIZARD_SURVEY_SUCCESS = exports.CREATE_WIZARD_SURVEY_SUCCESS = 'CREATE_WIZARD_SURVEY_SUCCESS';
var CREATE_WIZARD_SURVEY_FAILURE = exports.CREATE_WIZARD_SURVEY_FAILURE = 'CREATE_WIZARD_SURVEY_FAILURE';
var createWizardSurvey = exports.createWizardSurvey = function createWizardSurvey(surveyTypeID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [CREATE_WIZARD_SURVEY_REQUEST, CREATE_WIZARD_SURVEY_SUCCESS, CREATE_WIZARD_SURVEY_FAILURE],
    method: 'POST',
    authenticated: true,
    endpoint: 'surveys/WizardSurvey',
    payload: surveyTypeID
  });
};
var saveSurveyChanges = exports.saveSurveyChanges = function saveSurveyChanges(surveyID, entityID, changes) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SAVE_SURVEY_CHANGES_REQUEST, SAVE_SURVEY_CHANGES_SUCCESS, SAVE_SURVEY_CHANGES_FAILURE],
    method: 'PUT',
    authenticated: true,
    endpoint: "surveys/SaveChanges?id=".concat(surveyID, "&entityID=").concat(entityID),
    payload: changes
  });
};
var downLoadSurveyPDF = exports.downLoadSurveyPDF = function downLoadSurveyPDF(surveyID, language, option, entities) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [DOWNLOAD_SURVEY_PDF_REQUEST, DOWNLOAD_SURVEY_PDF_SUCCESS, DOWNLOAD_SURVEY_PDF_FAILURE],
    authenticated: true,
    endpoint: "surveys/DownloadPdf/".concat(surveyID, "?language=").concat(language, "&option=").concat(option, "&entities=").concat(entities),
    method: 'GET',
    isBlob: true
  });
};
var downLoadSurveyType = exports.downLoadSurveyType = function downLoadSurveyType(surveyTypeID, language) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [DOWNLOAD_SURVEY_TYPE_REQUEST, DOWNLOAD_SURVEY_TYPE_SUCCESS, DOWNLOAD_SURVEY_TYPE_FAILURE],
    authenticated: true,
    endpoint: "surveyTypes/Download/".concat(surveyTypeID, "?language=").concat(language),
    method: 'GET',
    isBlob: true
  });
};
var createSurvey = exports.createSurvey = function createSurvey(data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [CREATE_SURVEY_REQUEST, CREATE_SURVEY_SUCCESS, CREATE_SURVEY_FAILURE],
    authenticated: true,
    endpoint: "surveys",
    method: 'POST',
    payload: data
  });
};
var SET_SURVEY = exports.SET_SURVEY = 'SET_SURVEY';
var submitSurvey = exports.submitSurvey = function submitSurvey(surveyID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SUBMIT_SURVEY_REQUEST, SUBMIT_SURVEY_SUCCESS, SUBMIT_SURVEY_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(surveyID, "/submit"),
    method: 'POST'
  });
};
var saveSurvey = exports.saveSurvey = function saveSurvey(surveyID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SAVE_SURVEY_REQUEST, SAVE_SURVEY_SUCCESS, SAVE_SURVEY_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(surveyID),
    method: 'PUT',
    payload: data
  });
};
var setAssessmentSectionsComplete = exports.setAssessmentSectionsComplete = function setAssessmentSectionsComplete(assessmentID, entityID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SET_ASSESSMENT_SECTIONS_COMPLETE_REQUEST, SET_ASSESSMENT_SECTIONS_COMPLETE_SUCCESS, SET_ASSESSMENT_SECTIONS_COMPLETE_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(assessmentID, "/").concat(entityID, "/setAssessmentSectionsComplete"),
    method: 'POST'
  });
};
var getSurvey = exports.getSurvey = function getSurvey(surveyID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_SURVEY_REQUEST, GET_SURVEY_SUCCESS, GET_SURVEY_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(surveyID),
    method: 'GET'
  });
};
var getSurveys = exports.getSurveys = function getSurveys() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_SURVEYS_REQUEST, GET_SURVEYS_SUCCESS, GET_SURVEYS_FAILURE],
    authenticated: true,
    endpoint: "surveys/",
    method: 'GET'
  });
};
var deleteSurvey = exports.deleteSurvey = function deleteSurvey(surveyId) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [DELETE_SURVEY_REQUEST, DELETE_SURVEY_SUCCESS, DELETE_SURVEY_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(surveyId),
    method: 'DELETE'
  });
};
var getSurveyType = exports.getSurveyType = function getSurveyType(surveyTypeID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_SURVEY_TYPE_REQUEST, GET_SURVEY_TYPE_SUCCESS, GET_SURVEY_TYPE_FAILURE],
    authenticated: true,
    endpoint: "surveyTypes/".concat(surveyTypeID),
    method: 'GET'
  });
};
var getSurveyTypes = exports.getSurveyTypes = function getSurveyTypes() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_SURVEY_TYPES_REQUEST, GET_SURVEY_TYPES_SUCCESS, GET_SURVEY_TYPES_FAILURE],
    authenticated: true,
    endpoint: "surveyTypes",
    method: 'GET'
  });
};
var getUserSurveys = exports.getUserSurveys = function getUserSurveys() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_USER_SURVEYS_REQUEST, GET_USER_SURVEYS_SUCCESS, GET_USER_SURVEYS_FAILURE],
    authenticated: true,
    endpoint: "surveys/mySurveys",
    method: 'GET'
  });
};
var getSurveyScore = exports.getSurveyScore = function getSurveyScore(surveyID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_SURVEY_SCORE_REQUEST, GET_SURVEY_SCORE_SUCCESS, GET_SURVEY_SCORE_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(surveyID, "/score"),
    method: 'GET'
  });
};
var getSurveyAMAMScore = exports.getSurveyAMAMScore = function getSurveyAMAMScore(surveyID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_SURVEY_AMAM_SCORE_REQUEST, GET_SURVEY_AMAM_SCORE_SUCCESS, GET_SURVEY_AMAM_SCORE_FAILURE],
    authenticated: true,
    endpoint: "surveys/".concat(surveyID, "/AMAMScore"),
    method: 'GET'
  });
};
var setSurvey = exports.setSurvey = function setSurvey(survey) {
  return {
    type: SET_SURVEY,
    response: survey
  };
};
var SAVE_ASSESSMENT_AGREEMENT_REQUEST = exports.SAVE_ASSESSMENT_AGREEMENT_REQUEST = 'SAVE_ASSESSMENT_AGREEMENT_REQUEST';
var SAVE_ASSESSMENT_AGREEMENT_SUCCESS = exports.SAVE_ASSESSMENT_AGREEMENT_SUCCESS = 'SAVE_ASSESSMENT_AGREEMENT_SUCCESS';
var SAVE_ASSESSMENT_AGREEMENT_FAILURE = exports.SAVE_ASSESSMENT_AGREEMENT_FAILURE = 'SAVE_ASSESSMENT_AGREEMENT_FAILURE';
var saveAssessmentAgreement = exports.saveAssessmentAgreement = function saveAssessmentAgreement(surveyID, userFirstName, userLastName) {
  var data = {
    surveyID: surveyID,
    firstName: userFirstName,
    lastName: userLastName
  };
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SAVE_ASSESSMENT_AGREEMENT_REQUEST, SAVE_ASSESSMENT_AGREEMENT_SUCCESS, SAVE_ASSESSMENT_AGREEMENT_FAILURE],
    authenticated: true,
    endpoint: "surveys/fileAssessmentAgreement",
    method: 'POST',
    payload: data
  });
};